import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Table, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SubServicesImages = () => {
    const [editId, setEditId] = useState(null)
    const [subServiceImages, setSubServiceImages] = useState([]);
    const [filterImages, setFilterImages] = useState([])
    const [subServices, setSubServices] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("add");
    const [formData, setFormData] = useState({
        sub_service_id: "",
        image: null,
        link: ""
    });

    const baseUrl = "https://api.glyphqai.com";

    useEffect(() => {
        fetchSubServiceImages();
        fetchSubServices();
    }, []);

    const fetchSubServiceImages = () => {
        axios.get(`${baseUrl}/api/get-serviceimg`)
            .then(response => {
                if (response.data.status === 200) {
                    setSubServiceImages(response.data.sub_service_images);
                    setFilterImages(response.data.sub_service_images);
                }
            })
            .catch(error => console.error("Error fetching sub-service images:", error));
    };

    const fetchSubServices = () => {
        axios.get(`${baseUrl}/api/get-subservice`)
            .then(response => {
                if (response.data.status === 200) {
                    setSubServices(response.data.sub_services);
                }
            })
            .catch(error => console.error("Error fetching sub services:", error));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, image: e.target.files[0] });
    };

    const handleOpenModal = (type, image = null, id = null) => {
        setEditId(id);
        setModalType(type);
        setFormData({
            sub_service_id: image ? image.sub_service_id : "",
            link: image ? image.link : "",
            image: null
        });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        let requestData;
        const isAddMode = modalType === "add";

        const formPayload = new FormData();
        formPayload.append("sub_service_id", formData.sub_service_id);
        formPayload.append("image", formData.image);
        if (formData.link) {
            formPayload.append("link", formData.link);
        }
        requestData = formPayload;
        if (!isAddMode) {
            requestData.append("_method", "PUT")
        }

        const apiUrl = isAddMode
            ? `${baseUrl}/api/store-serviceimg`
            : `${baseUrl}/api/update-serviceimg/${editId}`;

        axios({
            method: "post",
            url: apiUrl,
            data: requestData,
            // headers: isAddMode
            //     ? { "Content-Type": "multipart/form-data" }
            //     : { "Content-Type": "application/json" },
        })
            .then((response) => {
                if (response.data.status === 200) {
                    toast.success(isAddMode ? "Image added successfully!" : "Image updated successfully!");
                    fetchSubServiceImages();
                    handleCloseModal();
                } else {
                    toast.error("Error: " + response.data.message);
                }
            })
            .catch((error) => {
                console.error(`Error ${isAddMode ? "adding" : "updating"} image:`, error);
                toast.error("Operation failed. " + (error.response?.data?.message || "Unknown error"));
            });
    };

    const handleDelete = (id) => {
        axios.delete(`${baseUrl}/api/deleteserviceimg/${id}`)
            .then(() => {
                setSubServiceImages(subServiceImages.filter(image => image.id !== id));
                toast.success("Image deleted successfully!");
            })
            .catch(error => {
                console.error("Error deleting image:", error);
                toast.error("Failed to delete image.");
            });
    };

    const handleChange = (e) => {
        const value = e.target.value;
        if (value == "all") {
            setFilterImages(subServiceImages);
        } else {
            setFilterImages(subServiceImages.filter(sub => sub.sub_service_id == value));
        }

    }

    return (
        <>
            <ToastContainer />
            <div className="container">
                <div className="my-3 mt-5 d-flex justify-content-between">
                    <h2 className="font-bold display-5">Sub Service Images</h2>
                    <Button onClick={() => handleOpenModal("add")}>Add Image</Button>
                </div>

                <div>
                    <h3>Filter by Sub Service:</h3>
                    <Form.Select className="mb-5" onChange={handleChange}>
                        <option value="all">All Sub Service Images</option>
                        {
                            subServices.map(sub => (<option key={sub.id} value={sub.id}>{sub.title}</option>))
                        }
                    </Form.Select>
                </div>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Sub Service ID</th>
                            <th>Link</th>
                            <th>Image</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filterImages.map((image, index) => (
                            <tr key={image.id}>
                                <td>{index + 1}</td>
                                <td>{subServices.find(sub => String(sub.id) === image.sub_service_id)?.title}</td>
                                <td>{image.link ? <a href={image.link} target="_blank" rel="noopener noreferrer">View Link</a> : "N/A"}</td>
                                <td>
                                    <img
                                        src={`${baseUrl}/uploads/subservices/${image.image}`}
                                        alt="Sub Service"
                                        style={{
                                            width: "50px",
                                            height: "50px"
                                        }}
                                    />
                                </td>
                                <td>
                                    <Button onClick={() => handleOpenModal("edit", image, image.id)}>Edit</Button>
                                    <Button variant="danger" onClick={() => handleDelete(image.id)}>Delete</Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalType === "add" ? "Add Image" : "Edit Image"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group>
                            <Form.Label>Sub Service</Form.Label>
                            <Form.Select
                                name="sub_service_id"
                                value={formData.sub_service_id}
                                onChange={handleInputChange}
                                required
                            >
                                <option value="">Select a sub service</option>
                                {subServices.map(service => (
                                    <option key={service.id} value={service.id}>
                                        {service.title}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formLink" className="mt-3">
                            <Form.Label>Link</Form.Label>
                            <Form.Control
                                type="url"
                                placeholder="Enter link"
                                name="link"
                                value={formData.link}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        {true &&
                            <Form.Group controlId="formImage" className="mt-3">
                                <Form.Label>Image</Form.Label>
                                <Form.Control
                                    type="file"
                                    name="image"
                                    onChange={handleFileChange}
                                    required
                                />
                            </Form.Group>
                        }
                        <Button type="submit" className="mt-3">{modalType === "add" ? "Add Image" : "Update Image"}</Button>
                    </Form>
                </Modal.Body>
            </Modal>

            <ToastContainer />
        </>
    );
};

export default SubServicesImages;
